import styled, { css } from 'styled-components'
import { SPACING, TYPOGRAPHY, FONT_WEIGHT } from '../../../../styles/theme'
import { QuestionLabel, InputWrapper, HintText, interactiveBase, selectedStyle } from './shared'

interface ScaleQuestionProps {
  question: string
  value: number | null
  onChange: (value: number) => void
  /** Upper bound of the rating scale (defaults to 5). 10 is used for Ulwick ODI pairs. */
  max?: number
}

const ScaleRow = styled.div`
  display: flex;
  gap: ${SPACING.sm};
  width: 100%;
`

const ScaleButton = styled.button<{ $selected: boolean }>`
  ${interactiveBase}
  flex: 1;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.bold};
  border-width: 1px;
  border-style: solid;
  padding: 0;

  ${({ $selected }) =>
    $selected &&
    css`
      ${selectedStyle}
    `}
`

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${SPACING.xs};
`

export function ScaleQuestion({ question, value, onChange, max = 5 }: ScaleQuestionProps) {
  const points = Array.from({ length: max }, (_, i) => i + 1)
  return (
    <InputWrapper>
      <QuestionLabel>{question}</QuestionLabel>
      <ScaleRow role="group" aria-label={question}>
        {points.map((n) => (
          <ScaleButton
            key={n}
            type="button"
            $selected={value === n}
            onClick={() => onChange(n)}
            aria-pressed={value === n}
            aria-label={`${n} out of ${max}`}
          >
            {n}
          </ScaleButton>
        ))}
      </ScaleRow>
      <Labels>
        <HintText>Not at all</HintText>
        <HintText>Extremely</HintText>
      </Labels>
    </InputWrapper>
  )
}
